<template>
	<div class="w-100">
		<div 
		data-aos="zoom-in"
		class="alert alert-danger" 
		style="display: flex; align-items: flex-end; justify-content: center;"
		v-if="cnt_pass>0"
		>
			<textInput 
			class="col-6"
			label="کد تایید کلاس"
			type="number"
			@inputTxtFunc="(e)=>{res_pass=e}"
			:val="res_pass"
			/>
			<btn 
				text="ثبت"
				@clickMe="sav_res()"
			/>
		</div>


		<div
			v-for="(f, i) in flds.content"
			:key="i"
			class="w-100 p-3 overflow-hidden shadow border-15 border mb-3 bg-white"
		>
			<div class="col-lg-2 col-md-3 col-3 float-right text-center p-0">
				<userImg
					:imgSize="(windowWidth < 570) ? windowWidth/6 : '120'"
					:src="f.img"
				/>
			</div>
			<div class="col-lg-6 col-md-6 col-9 float-right">
				<div class="">
					<p class="bMikhak">
						<span class="bMikhak" v-if="f.teachers_fullname != '' && f.teachers_fullname != null">
							{{f.teachers_fullname}}
						</span>
						<span class="bMikhak text-orange" v-else>
							(نامشخص)
						</span>

						&nbsp;
						<img
							:src="require('../../assets/img/Arrow_Left_Long.svg')"
							v-if="f.teachers_fullname2 != ''"
							v-show="windowWidth > 570"
						/>
						&nbsp;
						<span class="bMikhak" v-if="f.teachers_fullname2 != '' && f.teachers_fullname2 != null && f.teachers_fullname2 != ''">
							{{f.teachers_fullname2}}
						</span>
						<span class="bMikhak text-orange" v-else-if="f.teachers_fullname2 != ''">
							(نامشخص)
						</span>
					</p>
					<div class="bMikhak text-success" :class="(windowWidth < 767) ? '' : 'mt-4' " >
						<i class="fa fa-chalkboard-teacher" v-if="f.knd_class_id==1"></i>
						<i class="fa fa-laptop" v-else-if="f.knd_class_id==2"></i>
						<i class="fa fa-home" v-else-if="f.knd_class_id==3"></i>
						&nbsp;
						<span v-if="f.date_class != '' && f.date_class != null">
							{{f.knd_class_name}}
						</span>
						<span v-else>
							پیشنهاد مدرس
						</span>
					</div>
					<span v-if="windowWidth >= 570">
						<div class="text-truncate yekan mt-3" v-if="f.date_class != '' && f.date_class != null">
							زمان جلسه:
							{{f.date_class}} - {{f.time_class.start}} تا {{f.time_class.end}}
						</div>
						<div class="text-truncate yekan mt-3" v-else>
							زمان جلسه:
							<span class="text-orange">
								(نامشخص)
							</span>
						</div>
						<div class="text-truncate yekan mt-3">
							<span class="bMikhak text-success" v-if="f.status_id==8" >
								کلاس اجرا و تایید شده است
								<b class="text-danger" v-if="f.admins_fullname">
									<br>
									تایید شده توسط: 
									<b style="color:black">{{ f.admins_fullname }}</b>
									در تاریخ 
									<b style="color:black">{{ f.admins_date }}</b>
								</b>
							</span>
							<span class="bMikhak text-orange" v-else-if="f.status_id==2 && f.date_class==flds.now" >
								کلاس امروز اجرا می‌شود
							</span>
							<span class="bMikhak text-danger" v-else-if="f.status_id==2 && f.date_class<flds.now" >
								اجرای کلاس تایید نشده است
							</span>
							<span class="bMikhak text-danger" v-else-if="f.status_id==2 && f.date_class>flds.now" >
								کلاس آغاز نشده است
							</span>
						</div>
						<div class="text-truncate yekan mt-3" 
						v-if="$localStorage.get('user').username.role=='3' && f.status_id=='2' && $localStorage.get('user').username.access_level=='0'">
							<span class="bMikhak text-success pointer" @click="set_status(i)">
								<img
									class="ml-1"
									:src="require('../../assets/img/Tick-Circle.svg')"
									width="25"
								/>
								کلاس انجام شد
							</span>
						</div>
					</span>
				</div>
			</div>
			<span class="text-white" style="font-size: 1px;">.</span>
			<div class="col-12" v-show="windowWidth < 570">
				<div class="text-truncate yekan mt-3" v-if="f.date_class != '' && f.date_class != null">
					زمان جلسه:
					{{f.date_class}} - {{f.time_class.start}} تا {{f.time_class.end}}
				</div>
				<div class="text-truncate yekan mt-3" v-else>
					زمان جلسه:
					<span class="text-orange">
						(نامشخص)
					</span>
				</div>
			</div>
			<div
				class="col-lg-4 col-md-3 col-sm-12 col-xs-12"
				:class="(windowWidth >= 767) ? 'float-right' : 'mt-3' "
			>
				<div
					class="bMikhak "
					:class="(windowWidth < 767) ? '' : 'text-left' "
				>
					<span style="font-size: 12px;">
						تاریخ خرید:
					</span>
					<br v-show="windowWidth >= 767" />
					<span class="text-success yekan"  v-if="(f.status_id != 1 && f.status_id != 5 && f.status_id != 6 )">
						{{f.date}}
						<br v-show="windowWidth >= 767" />
						{{f.time}}
					</span>
					<span class="text-danger yekan"  v-else>
						در انتظار پرداخت
					</span>
				</div>
				<router-link :to="'/reserved/user/'+f.id" v-if="!['1','4','5','6','7','8'].includes($localStorage.get('user').username.access_level)">
					<btn
						type="orange"
						class="float-left mt-3"
						text="مشاهده"
						:class="(windowWidth < 767) ? 'w-100' : '' "
						:textClass="(windowWidth < 767) ? 'w-100' : '' "
					/>
				</router-link>
			</div>

		</div>
		<div class="w-100" style="display: flex; align-items: center; justify-content: center;">
			<pageNavigation :page="flds.curPage" :pages="flds.totalPages" @setPage="setPage"  />
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import userImg from  "../../UI/userImg/userImg.vue";
		import textInput from  "../../UI/input/textInput.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		import { error, success } from  "../../assets/library/messege.js";
		export default {
			name: 'teachers_part1',
			data(){
				return {
					res_pass: "",
					cnt_pass: "0",
					error: error, 
					success: success,
				}
			},
			components: {
				btn,
				pageNavigation,
				textInput,
				userImg,
			},
			props: {
				flds: {
					default: [],
				},
			},
			mounted(){
			if(this.$localStorage.get('user').username.role==2){
				this.loading();
			}
			},
			methods:{
				set_status(i){
					var data = this.flds.content[i];
					var html = "آیا کلاس استاد <b>"+data.teachers_fullname+ "</b> در تاریخ <b>"+data.date_class+"</b> تشکیل شده است؟";
					this.$swal.fire({
						position: 'center',
						type: 'question',
						title: "تشکیل کلاس",
						html: "<div class='text-center w-75 m-auto'><hr/> "+html+" </div>",
						showCloseButton: true,
						showConfirmButton: true,
						confirmButtonText: "بلی",
						confirmButtonClass:"btn btn-success border w-50",
						showCancelButton: true,
						cancelButtonText: "خیر",
						cancelButtonClass:"btn btn-danger w-50",
					}).then((result) => {
						if(result.value){
							this.set_statusF(data.id)
						}
					})
				},
				//***************************************
				set_statusF(id, THIS = this){
					window.$.post(window.baseurl + 'reserved/'+id , {
							token: this.$localStorage.get("user"),
							mode: "set_status_admin",
						}, function (D) {
							THIS.success(THIS)
							THIS.$emit('setPage', THIS.$route.query.page);
						}, "json");
				},
				//***************************************
				setPage(page){
					this.$emit('setPage', page);
				},
				//***************************************
				sav_res(THIS = this){
					if(this.res_pass==""){
						THIS.error(THIS, 'کد تایید کلاس را وارد نمایید')
					}else{
						window.$.post(window.baseurl + 'reserved/password', {
							token: this.$localStorage.get("user"),
							password: this.res_pass,
						}, function (D) {
							if(D.ok){
								THIS.success(THIS, D.data)
								THIS.loading()
							}else{
								THIS.res_pass = "";
								THIS.error(THIS, D.message)
							}
						}, "json");
					}
				},
				//***************************************
				loading(THIS = this){
					window.$.post(window.baseurl + 'reserved/password', {
						token: this.$localStorage.get("user"),
					}, function (D) {
						THIS.cnt_pass = D.data.cnt
					}, "json");
				}
				//***************************************
			}
		}
	</script>
<style>

</style>
